import Articles from '~/components/Articles'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/blog`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_blog_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_blog_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}

export default Articles
